export const breakpointMobileCompact = "only screen and (max-width: 320px)";
export const breakpointMobileMedium = "only screen and (max-width: 375px)";
export const breakpointMobileOnly = "only screen and (max-width: 480px)";
export const breakpointMobileExtendedPixels = "720px";
export const breakpointMobileExtended = "only screen and (max-width: 720px)";
export const breakpointDesktopOnly = "only screen and (min-width: 720px)";
export const breakpointWideDesktopOnly = "only screen and (min-width: 981px)";
